import { createFileRoute } from "@tanstack/react-router";
import { IVRForm } from "@/routes/_dashboard/ivr/-components/ivr-form";
import { usePermissionRedirect } from "@/hooks/use-permission-redirect";

type SearchParams = {
  showInfo?: boolean;
};

export const Route = createFileRoute("/_dashboard/ivr/new-ivr")({
  component: CreateIVRComponent,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    return {
      showInfo: search.showInfo as boolean | undefined,
    };
  },
  loader: async ({ context }) => {
    return {
      crumb: "New IVR",
      user: (context as any).user,
    };
  },
});

function CreateIVRComponent() {
  const { user } = Route.useLoaderData();
  usePermissionRedirect({
    user,
    permission: "IVR",
    checkType: "write",
    toastMessage: "You don't have permission to create IVRs.",
    redirectTo: "/ivr",
  });
  return <IVRForm ivr={null} isEdit={false} />;
}
